// extracted by mini-css-extract-plugin
export default {"chipLabel":"bNBOIBF0FJgvdBiIuOqL"};